import { render, staticRenderFns } from "./PhieuBaoHanhForm.vue?vue&type=template&id=378899c2&scoped=true&"
import script from "./PhieuBaoHanhForm.vue?vue&type=script&lang=js&"
export * from "./PhieuBaoHanhForm.vue?vue&type=script&lang=js&"
import style0 from "./PhieuBaoHanhForm.vue?vue&type=style&index=0&id=378899c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378899c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VContainer,VForm,VRow,VTextField})
